/**
 * Creates cumulative data for a series of dates starting from a given count.
 * Handles both individual date entries and aggregated data with counts per date.
 *
 * @param dates - An array of date strings or objects with date and count.
 * @param startCount - The initial count to start the cumulative data from.
 * @param isAggregated - A flag indicating if the data is aggregated with counts.
 * @returns An object with labels (dates) and datasets for use in charting libraries.
 */
export const createCumulativeData = (
  dates: (string | { date: string; count: number })[], 
  startCount: number,
  isAggregated: boolean
) => {
  // Explicitly define types for labels and cumulativeCounts
  let labels: string[] = [];
  let cumulativeCounts: number[] = [];
  let total = startCount;

  if (isAggregated) {
    // Handle aggregated data where each item has a date and a count
    dates.forEach((item) => {
      const { date, count } = item as { date: string; count: number };
      labels.push(date);
      total += Number(count); // Ensure count is treated as a number
      cumulativeCounts.push(total);
    });
  } else {
    // Handle individual date strings
    labels = dates as string[];
    cumulativeCounts = dates.map((_, index) => startCount + index + 1);
  }

  return {
    labels,
    datasets: [
      {
        label: 'Total Amount',
        data: cumulativeCounts,
        fill: false,
        backgroundColor: '#1f77b4',
        borderColor: '#1f77b4',
        pointRadius: 1,
        borderWidth: 2,
      },
    ],
  };
};
